import { render, staticRenderFns } from "./IusaWater.vue?vue&type=template&id=c00c2674&"
import script from "./IusaWater.vue?vue&type=script&lang=js&"
export * from "./IusaWater.vue?vue&type=script&lang=js&"
import style0 from "./IusaWater.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports